module.exports = __webpack_public_path__ + "img/arrow_impetus_white.1dbd6a16.png";